exports.components = {
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-templates-trabajador-template-index-js": () => import("./../../../src/templates/trabajador-template/index.js" /* webpackChunkName: "component---src-templates-trabajador-template-index-js" */),
  "component---src-templates-trabajadores-list-index-jsx": () => import("./../../../src/templates/trabajadores-list/index.jsx" /* webpackChunkName: "component---src-templates-trabajadores-list-index-jsx" */)
}

